import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import queryString from 'query-string';
import ReactPaginate from 'react-paginate';

import {
  fetchShipments,
  fetchShipmentsSuccess,
  fetchShipmentsFailure,
  fetchDestinations,
  fetchDestinationsSuccess,
  fetchDestinationsFailure,
} from "../../store/shipments/actions";

import { STARTING_PAGE } from '../../constants/constants';

import Spinner from '../../components/generics/Spinner';
import  { EmptyTable, ShipmentTable } from '../../components/shipments/ShipmentsList';
import Filter from '../../components/generics/Filter';
import ListHeader from '../../components/generics/ListHeader';
import { withRouter } from "utils/WithRouter";

export class ShipmentListContainer extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);

    this.state = {
      currentPage: STARTING_PAGE,
      shipmentId: '',
      itemName: '',
      shipmentDate: '',
      shipmentCustomer: undefined
    };
    this.debounceSearch = _.debounce(this.filterList, 300);
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    const shipmentCustomer = params.customer ? params.customer : undefined;
    const shipmentDate = params.date ? params.date : '';
    const shipmentId = params.shipment ? params.shipment : '';
    const itemName = params.item ? params.item : '';
    const currentPage = params.page ? params.page : STARTING_PAGE;

    this.setState({ currentPage, shipmentId, itemName, shipmentDate, shipmentCustomer }, () => {
      this.props.fetchShipments(currentPage, shipmentId, itemName, shipmentDate, shipmentCustomer);
    });
    if (this.props.destinationsList.destinations.length === 0){
      this.props.fetchDestinations();
    }
  }

  // ---------------------------------------------------------------------------
  // Pagination handling
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let currentPage = data.selected + 1;
    if(currentPage !== this.state.currentPage){
      this.setState({ currentPage }, () => {
          this.filterList();
      });
    };
  };

  // ---------------------------------------------------------------------------
  // Filters
  // ---------------------------------------------------------------------------
  onSearchChange = (event) => {
    let value = event.target ? event.target.value : '';
    let shipmentId, itemName = '';
    if (isNaN(parseInt(value, 0))) {
      itemName = value;
    } else {
      shipmentId = value;
    }
    this.setState({ shipmentId, itemName, currentPage: STARTING_PAGE }, () => {
      this.debounceSearch();
    });
  };

  onDateChange = (event) => {
    let shipmentDate = event.target.value ? event.target.value : '';
    this.setState({ shipmentDate, currentPage: STARTING_PAGE }, () => {
      this.filterList();
    });
  };

  onCustomerChange = (event) => {
    let shipmentCustomer = event.target.value && event.target.value > -1 ? event.target.value : undefined;
    this.setState({ shipmentCustomer, currentPage: STARTING_PAGE }, () => {
      this.filterList();
    });
  };

  filterList = () => {
    let params = {};
    if (this.state.shipmentId){
      params.shipment = this.state.shipmentId;
    }
    if (this.state.itemName) {
      params.item = this.state.itemName;
    }
    if (this.state.shipmentDate){
      params.date = this.state.shipmentDate;
    }
    if (this.state.shipmentCustomer){
      params.customer = this.state.shipmentCustomer;
    }
    params.page = this.state.currentPage;
    this.props.history.push({
      search: queryString.stringify(params)
    });
    this.props.fetchShipments(this.state.currentPage,
                             this.state.shipmentId,
                             this.state.itemName,
                             this.state.shipmentDate,
                             this.state.shipmentCustomer);
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
    return (
      <div className="animated fadeIn shipment">
        <div className="card">
          <ListHeader title="Shippings"
                      iconClass="fa fa-truck mr-05"
                      actionLink={'/shipment/new'} />

          <Filter
            searchLabel="Search"
            searchPlaceholder="Shipment ID or Item Name"
            searchVal={this.state.shipmentId}
            onSearchChange={this.onSearchChange}
            dateLabel="Shipment Date"
            dateVal={this.state.shipmentDate}
            onDateChange={this.onDateChange}
            dropdownLabel="Customer"
            dropdownPlaceholder="Select customer"
            dropdownVal={this.state.shipmentCustomer}
            onDropdownChange={this.onCustomerChange}
            dropdownByElementId
            dropdownOptions={this.props.destinationsList.destinations}
          />
          </div>

        <div className="card">
          <div className="card-block p-0">
            {/* Table */}
            {this.props.shipmentList.shipments.length === 0 ?
                <EmptyTable />
            :
                <ShipmentTable list={this.props.shipmentList.shipments} />
            }
          </div>
        {/* Pagination */}
        {this.props.shipmentList.pages > 1 &&
          <ReactPaginate pageCount={this.props.shipmentList.pages}
                         pageRangeDisplayed={2}
                         marginPagesDisplayed={1}
                         previousLabel="<"
                         nextLabel=">"
                         onPageChange={this.handlePageRequest}
                         initialPage={this.state.currentPage-1}
                         disableInitialCallback={true}
                         containerClassName="pagination"
                         pageClassName="page-item"
                         pageLinkClassName="page-link"
                         activeClassName="page-item active"
                         previousClassName="paginate_button previous"
                         nextClassName="paginate_button next"
                         disabledClassName="page-item disabled"
                         forcePage={this.state.currentPage-1}/>
        }
        </div>
        {/* Spinner */}
        {this.props.shipmentList.loading && <Spinner />}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    shipmentList: state.shipments.shipmentList,
    destinationsList: state.shipments.destinationsList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchShipments: (page, id, itemName, date, dest) => {
      dispatch(fetchShipments(page, id, itemName, date, dest)).payload.then((response) => {
        dispatch(fetchShipmentsSuccess(response.data))
      }, (error) => {
        dispatch(fetchShipmentsFailure(error));
      });
    },
    fetchDestinations: (data) => {
      dispatch(fetchDestinations()).payload.then((response) => {
        dispatch(fetchDestinationsSuccess(response.data));
      }, (error) => {
        dispatch(fetchDestinationsFailure(error));
      });
    }
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(ShipmentListContainer));
